import React, { useEffect } from 'react'
import Albums from '../components/Albums'
import ArtistCard from '../components/ArtistCard'
import { useSelector, useDispatch } from 'react-redux'
import { bandFetchAction } from '../store/actions/bandFetchAction'
import { useParams } from 'react-router-dom'
import '../assets/Band.css'

const Band = () => {
  const artistName = useParams().artistName
  const dispatch = useDispatch()
  const fetchedBand = useSelector(state => state.bandReducer.fetchedBand)
  const fetchedBandAlbums = useSelector(state => state.bandReducer.fetchedBandAlbums)

  useEffect(() => {
    dispatch(bandFetchAction(artistName))
    // eslint-disable-next-line
  }, [])

  return (
    <div className="container">
      <div>
        {fetchedBand.length < 1 && <h1> <i className="fas fa-sync fa-spin"></i> loading artist... </h1>}
        {fetchedBand.map((artist) => {
          return (
            <ArtistCard
              artist={artist}
              key={artist.idArtist}
            />
          )
        })}
      </div>
      <div className="mt-3">
        {fetchedBandAlbums.length < 1 && <h1> <i className="fas fa-sync fa-spin"></i> loading albums... </h1>}
        {
          fetchedBandAlbums.length > 0 &&
          <div>
            <h1>The Albums</h1>
            {fetchedBandAlbums.map((album) => (
              <div
                key={album.strAlbum}
                className="d-flex flex-row containerAlbum">
                <Albums
                  album={album}
                />
              </div>
            ))}
          </div>
        }
      </div>
    </div>
  )
}

export default Band
